import React from 'react'
import Card from './Card'
import GenericIcon from 'components/GenericIcon'

class LoanSummary extends React.Component {

  purposeTitle() {
    return I18n.t(`onboarding.summary.purpose.${this.props.loanApplication.loanPurpose}`)
  }

  purposeDescription() {
    if (this.props.loanApplication.loanPurpose == 'purchase') {
      return I18n.t(`onboarding.summary.target.${this.props.loanApplication.loanTarget}`)
    } else {
      return I18n.t(`onboarding.summary.refinance_reason.${this.props.loanApplication.refinanceReason}`)
    }
  }

  targetTitle() {
    if (this.props.loanApplication.loanPurpose == 'purchase') {
      if (this.props.loanApplication.hasFoundHome) {
        return I18n.t('onboarding.summary.location.has_found_home.yes')
      } else {
        return I18n.t('onboarding.summary.location.has_found_home.no')
      }
    } else {
      return I18n.t(`onboarding.summary.location.target.${this.props.loanApplication.loanTarget}`)
    }
  }

  fullAddressTargetDescription() {
    const {
      locationAddress,
      locationPostcode,
      locationSuburb,
      locationState,
    } = this.props.loanApplication

    return(
      <span>
        { `${locationAddress},` }
        <br />
        { `${ locationSuburb } ${ locationState } ${ locationPostcode } Australia` }
      </span>
    )
  }

  suburbTargetDescription() {
    const { locationPostcode, locationSuburb } = this.props.loanApplication

    if ( locationPostcode == undefined ) {
      return locationSuburb
    } else {
      return `${ locationPostcode } - ${ locationSuburb }`
    }
  }

  targetDescription() {
    const { hasFoundHome, loanPurpose } = this.props.loanApplication

    if ((loanPurpose == 'refinance') || hasFoundHome) {
      return this.fullAddressTargetDescription()
    } else {
      return this.suburbTargetDescription()
    }
  }

  borrowingTitle() {
    const { loanAmount } = this.props.loanApplication;

    if (loanAmount !== undefined) {
      let loanLabel = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 }).format(loanAmount)
      return `Borrowing ${loanLabel}`
    }
  }

  borrowingDescription() {
    const { loanRatio } = this.props.loanApplication
    const loanRatioLabel = Number(loanRatio * 100).toFixed(0)
    return `${loanRatioLabel}% of your home value`
  }

  render() {
    return(
      <Card className='shadow-none loan-details'>
        <br />
        <p><strong>Details of your loan</strong></p>
        <br />

        <div className='media'>
          <GenericIcon name='refinance' className='mr-3' />
          <div className='media-body'>
            { this.purposeTitle() }
            <p className='grey'>
              { this.purposeDescription() }
            </p>
          </div>
        </div>

        <hr />

        <div className='media'>
          <GenericIcon name='home' className='mr-3' />
          <div className='media-body'>
            { this.targetTitle() }
            <p className='grey'>
              { this.targetDescription() }
            </p>
          </div>
        </div>

        <hr />

        <div className='media'>
          <GenericIcon name='dollar' className='mr-3' />
          <div className='media-body'>
            { this.borrowingTitle() }
            <p className='grey'>
              { this.borrowingDescription() }
            </p>
          </div>
        </div>

      </Card>
    )
  }
}

export default LoanSummary;
